import { iListaPrecio } from "./iListaPrecio.model";

export class objArticulo {
    id_cia: number;
    tipinv: number;
    codart: string;
    descri: string;
    codmar: number;
    codubi: number;
    codprc: number;
    codmod: number;
    modelo: string;
    codobs: number;
    coduni: string = 'U/M';
    codlin: number;
    codori: string;
    codfam: number;
    codbar: string;
    parara: string;
    proart: string;
    codoem?: string;
    consto: number;
    codprv: string;
    agrupa: string = 'N';
    fcreac: string;
    fmatri: string;
    factua: string;
    usuari: string;
    wglosa: string;
    faccon: any;
    tusoesp: number;
    tusoing: number;
    diacmm: number;
    cuenta: string;
    conesp: number;
    linea: string;
    proint: string;
    codint: string;
    codope: number;
    situac: string;
    ucreac ?:string;
    uactua ?:string;
    stock: number;
    precio: iListaPrecio;
    codigosadd01: objCodigoDescripcion[];
    codigosadd02: objCodigoDescripcion[];
    clases: objClaseCodigoDescripcion[];
    clasesglobal: objClaseCodigoDescripcion[];
    imagenes: objCodigoDescripcion[];
    codigosean: objArticuloCodigoEAN[];
    especificaciones: objArticuloEspecificacion[];
    detraccion: iArticuloDetraccion[];
}

export class objCodigoDescripcion {
    codigo: string;
    descri: string;
}

export class objClaseCodigoDescripcion {
    id_cia: number;
    clase: number;
    desclase: string;
    codigo: string;
    descodigo: string;

}


export class objArticuloCodigoEAN {
    id_cia: number;
    item: number;
    ean: string;
}

export class objArticuloEspecificacion {
    id_cia: number;
    codesp: number;
    descri: string;
    vreal: number;
    vstrg: string;
    vchar: string;
    vdate: string;
    vtime: string;
    ventero: number;
}
export interface iArticuloDetraccion{
    id_cia: number;
    tipinv: number;
    codart: string;
    tasdet: string;
    tipope: string;
    tipbys: string;
}